
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Size=20"}},[_c('path',{attrs:{"id":"Vector","d":"M10 18a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8zM7.25 7.75C7.25 6.784 8.034 6 9 6h1.778a1.972 1.972 0 01.981 3.684l-1.009.579V11h-1.5V9.394l.378-.216 1.384-.794a.473.473 0 00-.234-.88H9a.25.25 0 00-.25.25v.202h-1.5V7.75zm2 5.75V12h1.5v1.5h-1.5z","fill":"#48535C"}})])])
          )
        }
      }
    